import { render, staticRenderFns } from "./AssignmentsSection.vue?vue&type=template&id=45591cb1&scoped=true&"
import script from "./AssignmentsSection.vue?vue&type=script&lang=js&"
export * from "./AssignmentsSection.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentsSection.vue?vue&type=style&index=0&id=45591cb1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45591cb1",
  null
  
)

export default component.exports